import RoomBlock from "./roomBlock2";

export default RoomBlock;